import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

export default function PartnersPage() {
  const partners = [
    {
      id: 1,
      name: 'Premium Fashion Co.',
      category: 'Fashion & Apparel',
      description: 'Leading fashion retailer providing exclusive collections',
      logo: '👗',
    },
    {
      id: 2,
      name: 'Tech Innovations Ltd.',
      category: 'Electronics',
      description: 'Cutting-edge technology products and gadgets',
      logo: '📱',
    },
    {
      id: 3,
      name: 'Home Comfort Plus',
      category: 'Home & Living',
      description: 'Quality furniture and home decor solutions',
      logo: '🛋️',
    },
    {
      id: 4,
      name: 'Beauty & Wellness',
      category: 'Beauty & Personal Care',
      description: 'Premium beauty and wellness products',
      logo: '💄',
    },
    {
      id: 5,
      name: 'Sports & Outdoors',
      category: 'Sports Equipment',
      description: 'Sports gear and outdoor adventure equipment',
      logo: '⚽',
    },
    {
      id: 6,
      name: 'Gourmet Delights',
      category: 'Food & Groceries',
      description: 'Premium food and gourmet products',
      logo: '🍽️',
    },
  ];

  return (
    <div className="min-h-screen bg-[#f5f6fb] flex flex-col">
      <main className="flex-1 w-full max-w-6xl mx-auto px-3 sm:px-6 lg:px-8 py-8 space-y-6">
        <nav className="text-xs text-gray-500 mb-2">
          <Link to="/" className="hover:text-gray-700">
            Home
          </Link>{' '}
          / <span className="text-gray-700 font-medium">Our Partners</span>
        </nav>

        <section className="bg-white rounded-[32px] shadow-lg border border-gray-100 p-6 sm:p-8 space-y-6">
          <h1 className="text-2xl font-bold text-gray-900">Our Partners</h1>
          <p className="text-sm text-gray-600">
            Dehleze partners with leading brands and trusted retailers to bring you the best products
            and shopping experience. Our partners are carefully selected to meet our quality standards
            and customer service commitments.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-8">
            {partners.map((partner) => (
              <div
                key={partner.id}
                className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 border border-gray-200 hover:shadow-md transition-shadow"
              >
                <div className="text-5xl mb-4">{partner.logo}</div>
                <h3 className="font-semibold text-lg text-gray-900">{partner.name}</h3>
                <p className="text-xs text-orange-600 font-medium mt-1">{partner.category}</p>
                <p className="text-sm text-gray-600 mt-3">{partner.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 bg-orange-50 rounded-lg p-6 border border-orange-100">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Want to Become Our Partner?</h2>
            <p className="text-sm text-gray-600 mb-4">
              If you're a vendor or brand interested in partnering with Dehleze, we'd love to hear from you!
            </p>
            <Link
              to="/work-with-us"
              className="inline-block bg-[#ff9100] text-white px-6 py-2 rounded-lg font-medium hover:bg-[#ff7a00] transition-colors"
            >
              Join Us
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
